/**
 * @shelf-version: 1.0.0
 */

import RafThrottle from './raf-throttle'

export default RafThrottle
